import { createApp } from 'vue'
import naive from 'naive-ui'
import { registerSW } from 'virtual:pwa-register'
import { pinia } from './pinia'
import router from './router'
import App from './App.vue'
import './css/main.css'

registerSW({ immediate: true })

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(naive)
app.mount('#app')
